import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { UserAdministration } from "../../../api";

export const userAdministrationKeys = {
  all: () => ["users"],
  usersStatuses: () => ["usersStatuses"],
  usersRoles: () => ["usersRoles"],
};

export function useGetUsers(paramsString, config) {
  const { callApi } = useAuth();
  return useQuery([...userAdministrationKeys.all(), paramsString],
    () => callApi(UserAdministration.getUsers, paramsString), config);
}

export function useGetUsersStatuses(params, config) {
  const { callApi } = useAuth();
  return useQuery([...userAdministrationKeys.usersStatuses(), params],
    () => callApi(UserAdministration.getUsersStatuses, params), config);
}

export function useGetUsersRoles(params, config) {
  const { callApi } = useAuth();
  return useQuery([...userAdministrationKeys.usersRoles(), params],
    () => callApi(UserAdministration.getUsersRoles, params), config);
}

export function useCreateUser(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(UserAdministration.createUser, data), config);
}

export function useAddExternalUser(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(UserAdministration.addExternalUser, data), config);
}

export function useUpdateUser(config) {
  const { callApi } = useAuth();
  return useMutation(({ id, data }) => callApi(UserAdministration.updateUser, { id, data }), config);
}

export function useResendInvitation(config) {
  const { callApi } = useAuth();
  return useMutation(id  => callApi(UserAdministration.resendInvitation, id), config);
}

export function useActivateUser(config) {
  const { callApi } = useAuth();
  return useMutation(id  => callApi(UserAdministration.activateUser, id), config);
}

export function useDeactivateUser(config) {
  const { callApi } = useAuth();
  return useMutation(id  => callApi(UserAdministration.deactivateUser, id), config);
}